import { Component, Vue } from 'vue-property-decorator';
import EventBus from '@/helpers/EventBus';
@Component({ components: {} })
export default class CartExpiryModal extends Vue {
    language;
    created() {
        this.language = this.$t('cartExpire');
    }
    confirm() {
        EventBus.$emit('close:modal:all');
    }
}
